(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rejection-reason', {
            parent: 'entity',
            url: '/rejection-reason?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.rejectionReason.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rejection-reason/rejection-reasons.html',
                    controller: 'RejectionReasonController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rejectionReason');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('rejection-reason-detail', {
            parent: 'entity',
            url: '/rejection-reason/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.rejectionReason.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rejection-reason/rejection-reason-detail.html',
                    controller: 'RejectionReasonDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rejectionReason');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RejectionReason', function($stateParams, RejectionReason) {
                    return RejectionReason.get({id : $stateParams.id});
                }]
            }
        })
        .state('rejection-reason.new', {
            parent: 'rejection-reason',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejection-reason/rejection-reason-dialog.html',
                    controller: 'RejectionReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rejection-reason', null, { reload: true });
                }, function() {
                    $state.go('rejection-reason');
                });
            }]
        })
        .state('rejection-reason.edit', {
            parent: 'rejection-reason',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejection-reason/rejection-reason-dialog.html',
                    controller: 'RejectionReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RejectionReason', function(RejectionReason) {
                            return RejectionReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('rejection-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rejection-reason.delete', {
            parent: 'rejection-reason',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejection-reason/rejection-reason-delete-dialog.html',
                    controller: 'RejectionReasonDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RejectionReason', function(RejectionReason) {
                            return RejectionReason.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('rejection-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
